import request from '@/router/axios';

//获取组织结构树结构根节点
export const getDeptTreeList = (tenantId) => {
  return request({
    url: '/api/v4ward/dept/custom-lazy-tree',
    method: 'get',
    params: {
      tenantId,
    },
  });
};

//获取组织结构树结构子节点
export const getDeptChildrenTreeList = (tenantId,parentId) => {
    return request({
      url: '/api/v4ward/dept/child-node',
      method: 'get',
      params: {
        tenantId,
        parentId:parentId
      },
    });
  };
//获取数据表字段数据类型
  export const getDbtypeList = (code) => {
    return request({
      url: '/api/blade-system/dict/dictionary?code=custom_field_type',
      method: 'get',
      params: {
        code
      },
    });
  };
//查看数据表字段详情
  export const getDbFeildTableList = (tableName,requestType,pageUrl,projectId,id) => {
    return request({
      url: '/api/v4ward/custom/table/field/list',
      method: 'get',
      params: {
        tableName,
        requestType,
        pageUrl,
        projectId,
        id
      },
    });
  };

//获取自定义扩展表字段数据
  export const getExtensionTableList = (pageUrl	 ,current ,size,projectId) => {
    return request({
      url: '/api/v4ward/custom/table/extend/page',
      method: 'get',
      params: {
        pageUrl,
        current,
        size,
        projectId
      },
    });
  };

//获取自定义共享表字段数据
  export const getPublicTableList = (pageUrl ,current ,size) => {
    return request({
      url: '/api/v4ward/custom/table/public/page',
      method: 'get',
      params: {
        pageUrl,
        current,
        size,
      },
    });
  };

//新增自定义扩展表
  export const submitExtendTableDataList = (data) => {
    return request({
      url: '/api/v4ward/custom/table/extend/create',
      method: 'post',
      params: {
        // pageUrl,
        // current,
        // size,
      },
      data: data,
    });
  };

//新增自定义共享表
  export const submitPublicTableDataList = (data) => {
    return request({
      url: '/api/v4ward/custom/table/public/create',
      method: 'post',
      params: {
        // pageUrl,
        // current,
        // size,
      },
      data: data,
    });
  };

//自定义共享表(开启/关闭)接口
  export const switchPublicTableButton = (data) => {
    return request({
      url: '/api/v4ward/custom/table/public-status',
      method: 'post',
      params: {
        // pageUrl,
        // current,
        // size,
      },
      data: data,
    });
  };

//自定义扩展表(开启/关闭)接口
  export const switchExtendTableButton = (data) => {
    return request({
      url: '/api/v4ward/custom/table/extend-status',
      method: 'post',
      params: {
        // pageUrl,
        // current,
        // size,
      },
      data: data,
    });
  };

//根据pageUrl获取数据表字段详情列表
  export const getTableFieldListDetail = (
    tableName,
    customType,
    pageUrl,
    projectId,
    id) => {
    return request({
      url: '/api/v4ward/custom/table/field/list',
      method: 'get',
      params: {
        tableName,
        customType,
        pageUrl,
        projectId,
        id
      },
    });
  };

//根据ID获取数据表字段详情
export const getTableFieldListDetailByID = (
  id,
  customType) => {
  return request({
    url: '/api/v4ward/custom/table/detail',
    method: 'get',
    params: {
      id,
      customType
    },
  });
};


export const removePublicTable = (publicTableId) => {
  return request({
    url: `/api/v4ward/custom/table/public/remove/${publicTableId}`,
    method: 'delete',
    params: {
      
    },
  });
};
export const removeExtendTable = (extendTableId) => {
  return request({
    url: `/api/v4ward/custom/table/extend/remove/${extendTableId}`,
    method: 'delete',
    params: {
      
    },
  });
};


// export const getProjectList = (params, options) =>
// request.get('', Object.assign({}, options, { params }));

export const getProjectList = () => {
  return request({
    url: '/api/v4ward/project/getProjectList',
    method: 'get',
    params: {},
  });
};